import React, { useCallback, useMemo } from 'react';
import Person from '@material-ui/icons/Person';
import { useBusinessCard } from './BusinessCard';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { Business } from '@material-ui/icons';

const HeaderContainer = styled.header`
  color: ${(p) => p.theme.textColor};
  display: grid;
  height: calc((5 * 4rem) + (5 * 0.5rem));
  grid-template-columns: 0.25rem 1fr 1fr 1fr 0.25rem;
  grid-template-rows: 0.25rem repeat(6, 4rem);
  grid-row-gap: 0.5rem;
  margin-bottom: 1rem;

  @media only screen and (min-width: 420px) {
    margin-bottom: 1.5rem;
  }
`;

const HeaderTop = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  background-image: url(${(p) => p.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  grid-column: 1 / span 5;
  grid-row: 1 / span 4;
`;

const PageCount = styled.div`
  grid-column: 2 / span 3;
  grid-row-start: 2;
  display: flex;
  font-size: 0.7rem;
  align-items: flex-end;
  justify-content: flex-start;
  justify-self: start;
  align-self: flex-start;
  line-height: 1rem;
`;

const PageCountText = styled.span`
  color: ${(props) => props.color};
  margin-left: 0.5rem;
`;

const PageCountValue = styled.span`
  color: ${(p) => p.theme.titleColor};
`;


const HeaderMenuActions = styled.div`
  grid-column: 4;
  grid-row: 3 / span 2;
  display: flex;
  flex-direction: column;
  justify-self: end;
  align-self: end;
  padding-bottom: 3px;
`;

const HeaderActions = styled.div`
  display: grid;
  column-gap: ${(p) => p.theme.dimensions.vw(1)}px;
  direction: ltr;
  grid-template-columns: repeat(3, ${(p) => p.theme.dimensions.vw(10)}px);
  justify-items: start;
`;
const ActionLink = styled.button`
  background: none;
  box-sizing: border-box;
  outline: none;

  width: ${(p) => p.theme.dimensions.vw(10)}px;
  height: ${(p) => p.theme.dimensions.vw(10)}px;
  color: ${(p) => p.theme.textColor};
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;

  > svg {
    width: ${(p) => p.theme.dimensions.vw(10)}px;
    height: ${(p) => p.theme.dimensions.vw(10)}px;
  }
`;

const Icon = styled.img`
  width: ${(p) => p.theme.dimensions.vw(10)}px;
  height: ${(p) => p.theme.dimensions.vw(10)}px;
`;

const Website = styled.a`
  color: ${(p) => p.theme.textColor};
  font-size: 0.7rem;
  text-align: left;
  justify-self: end;
  align-self: flex-end;
`;
const Header = ({
                  businessName,
                  avatarUri,
                  displayName,
                  position,
                  bio,
                  phoneNumber,
                  backgroundImage,
                  instagram,
                  facebook,
                  address,
                  avatar,
                  views,
                  website,
                  social,
                  openningHours,
                  font,
                  backgroundColor,
                  textColor,
                  logoBorderRadius,
                  avatarBorderRadius,
                  backgroundImageUri,
                  titleColor,
                  logo,
                  user,
                  onClubClick,
                  onCouponClick,
                  onPromoMovieClick,
                  cartItems,
                  history,
                  slug,
                  isSalePage,
                }) => {
  /*   const {
    dimensions: { vw },
  } = useBusinessCard(); */

  const instance = useBusinessCard();
  const {
    card: { couponText = null, promoVideo = null },
  } = instance;

  return (
    <HeaderContainer>
      <HeaderTop src={backgroundImageUri} />
      <PageCount>
        <PageCountText color={textColor}>צפיות</PageCountText>
        <PageCountText color={textColor}>{views}</PageCountText>
      </PageCount>
      <TopButtonsContainer>
        {(!!window.navigator?.share) && (
          <ShareButton>
            <ActionLink
              onClick={() => {
                if (window.navigator?.share) {
                  const title = businessName;
                  const url = window.location.href;
                  window.navigator.share({
                    title,
                    text: 'ברוכים הבאים לקטלוג שלי',
                    url,
                  });
                } else {
                  alert('אפשרות שיתוף זו אינה זמינה במכשירך');
                }
              }}
            >
              <Icon src="/images/social/share.png" />
            </ActionLink>
          </ShareButton>
        )}
        <ClubButton>
          <ActionLink
            onClick={() => {
              onClubClick();
            }}
          >
            <Icon src="/images/club.png" />
          </ActionLink>
        </ClubButton>
        {couponText && <CouponButton>
          <ActionLink
            onClick={() => {
              onCouponClick();
            }}
          >
            <Icon src="/images/coupon.png" />
          </ActionLink>
        </CouponButton>}
        {!!promoVideo && <ActionLink
          onClick={() => {
            onPromoMovieClick();
          }}
        >
          <Icon src="/images/movie.png" />
        </ActionLink>}
      </TopButtonsContainer>
      <HeaderMenuActions>
        <Website href={website} target="_blank" rel="noopener noreferrer">
          {website}
        </Website>
        <HeaderActions color={textColor}>
          {!!facebook && (
            <ActionLink
              onClick={() => {
                window.location.href = facebook;
              }}
            >
              <Icon src="/images/social/facebook.png" />
            </ActionLink>
          )}

          {!!instagram && (
            <ActionLink
              onClick={() => {
                window.location.href = instagram;
              }}
            >
              <Icon src="/images/social/instagram.png" />
            </ActionLink>
          )}
          {!!phoneNumber && (
            <ActionLink
              onClick={() => {
                const elem = document.createElement('a');
                elem.href = `tel://${phoneNumber}`;
                elem.click();
                elem.remove();
              }}
            >
              <Icon src="/images/social/phone.png" />
            </ActionLink>
          )}
        </HeaderActions>
      </HeaderMenuActions>
      <Nav />
      <ImageAlt>
        <PositionName>{[displayName, position].filter((i) => i).join(', ')}</PositionName>
        <br />
        <BusinessName>{businessName}</BusinessName>
      </ImageAlt>
      {isSalePage && <Cart onClick={() => history.push(`${slug}/cart`)}>
        <CartImage src="/images/cart.png"></CartImage>
        <CartBadge>{cartItems}</CartBadge>
      </Cart>}
      {avatarUri && (
        <HeaderImageContainer>
          <HeaderImage
            views={views}
            src={avatarUri}
            radius={avatarBorderRadius}
          />
        </HeaderImageContainer>
      )}

    </HeaderContainer>
  );
};

export default Header;

const BusinessName = styled.small`
  color: ${(p) => p.theme.titleColor};
`

const PositionName = styled.small`
  color: ${(p) => p.theme.titleColor};
`

const HeaderImageContainer = styled.div`
  grid-column: 3;
  grid-row: 3 / -2;
  align-self: center;
  justify-self: center;
`;
const HeaderImage = ({ src, radius, views, text }) => {
  const {
    dimensions: { vw },
    card: { titleColor },
  } = useBusinessCard();

  return (
    <Avatar
      src={src}
      variant={radius}
      style={{
        height: vw(33.3),
        width: vw(33.3),
        padding: 2,
        marginBottom: 0,
        background: 'transparent',
        border: `1px solid ${titleColor}`,
      }}
    />
  );
};

const TopButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-row: 2;
  grid-column: 4;
  justify-self: end;
`;

const ShareButton = styled.div``;

const ClubButton = styled.div``;

const CouponButton = styled.div``;

const Avatar = (props) => {
  const borderRadius = useMemo(() => {
    switch (props.variant) {
      case 'circular':
        return props?.style?.width / 2;
      case 'rounded':
        return '8px';
      default:
        return 0;
    }
  }, [props]);
  const InnerDisplay = () => {
    return props.src ? (
      <div
        style={{
          ...props.style,
          padding: 0,
          borderRadius,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            ...props.style,
            height: props.style.height - 8,
            width: props.style.width - 8,
            padding: 0,
            border: 0,
            objectFit: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: `${props.style.width - 8}px ${
              props.style.height - 8
            }px`,
            background: `url(${props.src})`,
            borderRadius,
          }}
        />
      </div>
    ) : (
      <div
        style={{
          ...props?.style,
          background: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius,
          backgroundColor: '#f3f3f3',
        }}
      >
        <Person
          style={{
            borderRadius:
              props.variant === 'circular'
                ? (props.style.width - 10) / 2
                : props.variant === 'rounded'
                ? 8
                : 0,
            color: '#a3a3a3',
            width: props.style.width - 20,
            height: props.style.height - 20,
          }}
        />
      </div>
    );
  };

  return (
    <div style={{ borderRadius }}>
      <InnerDisplay />
    </div>
  );
};

const ImageAlt = styled.p`
  grid-row: 6;
  grid-column: 2 / 5;
  font-size: 1.2em;
  color: ${(p) => p.theme.textColor};
`;

const CartBadge = styled.span`
  font-size: 12px;
  background: #ff0000;
  color: #fff;
  padding: 0 5px;
  vertical-align: top;
  margin-left: -10px;
  padding-left: 9px;
  padding-right: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
  position: absolute;
  top: 0;
  right: 0;
`;

const CartImage = styled.img`
  width: 50px;
  height 50px;
`;

const Cart = styled.div`
 position: relative
`;

const Nav = ({ displayName }) => {
  const { tab, setTab } = useBusinessCard();
  const toggleTab = useCallback(
    (newTab) => {
      if (tab === newTab) {
        setTab('idle');
      } else {
        setTab(newTab);
      }
    },
    [tab, setTab],
  );
  const { card } = useBusinessCard();
  const hasOpenningHours = useMemo(() => {
    return card?.openningHours?.find((item) => item.isOpen);
  }, [card]);
  return (
    <HeaderNav>
      {card.businessBio && (
        <HeaderNavLink onClick={() => toggleTab('bio')}>אודות</HeaderNavLink>
      )}
      {hasOpenningHours && (
        <HeaderNavLink onClick={() => toggleTab('openning-hours')}>
          שעות פעילות
        </HeaderNavLink>
      )}
    </HeaderNav>
  );
};

const HeaderNavLink = styled.button`
  background: none;
  outline: none;
  border: none;
  width: calc(${(p) => p.theme.dimensions.vw(7)}px * 2 +
  ${(p) => p.theme.dimensions.vw(1)}px);
  border: 0.5px solid ${(props) => props.theme.textColor};
  height: ${(p) => p.theme.dimensions.vw(7)}px;
  font-size: ${(p) => p.theme.dimensions.vw(2.5)}px;
  background-color: ${(p) => p.theme.rectangleColor};
  color: ${(p) => p.theme.textColor};
`;

const HeaderNav = styled.nav`
  grid-column: 4;
  grid-row: 5;
  direction: ltr;
  display: grid;
  grid-column-gap: ${(p) => p.theme.dimensions.vw(1)}px;
  grid-template-columns: repeat(2,
  calc(${(p) => p.theme.dimensions.vw(7)}px * 2 +
  ${(p) => p.theme.dimensions.vw(1)}px));
  justify-items: start;
`;
